import React, { useEffect } from 'react';
import { Camera, Mic, Shield } from 'lucide-react';
import './styles/RequestedModal.css';

const RequestedModal = ({ 
  isOpen, 
  requestedAccessName, 
  requesterName,
  displayName,
  adminId,
  acsRoomId,
  senderSocketIdGlobal,
  socket,
  clickOnVideoIcon,
  clickOnMuteUnmuteIcon,
  setIsRequestedModalOpen, 
  setRequestedAccessName 
}) => {
  const handleYes = () => {
    if (requestedAccessName === "Camera") {
      clickOnVideoIcon();
      socket.emit('BE-update-status', {
        acsRoomId,
        senderUserId: adminId,
        socketId: senderSocketIdGlobal,
        type: 'RequestAcceptedMessage',
      });
    } else {
      clickOnMuteUnmuteIcon();
      socket.emit('BE-update-status', {
        acsRoomId,
        senderUserId: adminId,
        socketId: senderSocketIdGlobal,
        type: 'RequestAcceptedMessage',
      });
    }
    setIsRequestedModalOpen(false);
    setRequestedAccessName("");
  };

  const handleNo = () => {
    socket.emit('BE-update-status', {
      acsRoomId,
      senderUserId: adminId,
      socketId: senderSocketIdGlobal,
      type: 'RequestDeniedMessage',
    });
    setIsRequestedModalOpen(false);
    setRequestedAccessName("");
  };

  // Keyboard shortcuts
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleYes();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        handleNo();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, requestedAccessName, requesterName]);

  if (!isOpen) return null;

  const isCameraRequest = requestedAccessName === "Camera";

  return (
    <div className="access-request-overlay">
      <div className="access-request-modal">
        {/* Icon at top */}
        <div className="access-request-icon-circle">
          {isCameraRequest ? (
            <Camera className="access-request-icon" size={40} />
          ) : (
            <Mic className="access-request-icon" size={40} />
          )}
        </div>

        {/* Heading */}
        <h2 className="access-request-heading">
          {requestedAccessName} Access Requested
        </h2>

        {/* Description */}
        <p className="access-request-description">
          {requesterName || "The host"} is asking you to turn on your {requestedAccessName.toLowerCase()}.
        </p>

        {/* Sub text */}
        <p className="access-request-subtext">
          Would you like to proceed ?
        </p>

        {/* Buttons */}
        <div className="access-request-buttons">
          <button onClick={handleYes} className="access-request-btn-yes">
            {isCameraRequest ? (
              <Camera size={20} />
            ) : (
              <Mic size={20} />
            )}
            <span>Yes</span>
          </button>
          <button onClick={handleNo} className="access-request-btn-no">
            <Shield size={20} />
            <span>No</span>
          </button>
        </div>

        {/* Footer hint */}
        <p className="access-request-footer">
          Press Enter to Allow • Escape to Deny
        </p>
      </div>
    </div>
  );
};

export default RequestedModal;
